module.exports = __webpack_public_path__ + "static/media/LOVES_FOOD_TREATS.4379cec7.svg";